import { AiSequenceGeneratorSteps } from '../../enums';
import CompanyInfoModal from './company-info-modal';
import CompanyWebsiteBusinessInfo from './company-website-business-info';
import GoalSelectionStep from './goal-selection-step';
import IcpForBusinessStep from './icp-for-business-step';
import KeyOfferingsStep from './key-offerings-step';
import OnBoardingStep from './on-boarding-step';
import RefineYourGoalStep from './refine-your-goal-step';
import SequenceEditStep from './sequence-edit-step';
import SequenceStepSelector from './sequence-selection-step';
/**
 * @description AI Sequence Generator Step Component Map
 * @returns {Object} AI Sequence Generator Step Component Map
 */
const AI_SEQ_STEP_COMPONENT_MAP = {
  [AiSequenceGeneratorSteps.INITIATE_AI_SEQUENCE]: OnBoardingStep,
  [AiSequenceGeneratorSteps.COMPANY_INFO]: CompanyWebsiteBusinessInfo,
  [AiSequenceGeneratorSteps.COMPANY_DATA_CONFIRM]: CompanyInfoModal,
  [AiSequenceGeneratorSteps.GOAL_SELECTION]: GoalSelectionStep,
  [AiSequenceGeneratorSteps.GOAL_REFINEMENT]: RefineYourGoalStep,
  [AiSequenceGeneratorSteps.SERVICE_SELECTION]: KeyOfferingsStep,
  [AiSequenceGeneratorSteps.ICP_GENERATION]: IcpForBusinessStep,
  [AiSequenceGeneratorSteps.SEQUENCE_LENGTH]: SequenceStepSelector,
  [AiSequenceGeneratorSteps.SEQUENCE_GENERATION]: SequenceEditStep,
};

export default AI_SEQ_STEP_COMPONENT_MAP;
